import { JourneyDataModel } from '../../../services/redux/features/journeyData.slice';
import { AddressFormModel_OL } from './formModel';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const requestMapper = (values: AddressFormModel_OL): Partial<JourneyDataModel> => {
  return {};
};
